const theme = {
    fontFamily: {
        reg: 'Nimbus Sans Reg',
        bold: 'Nimbus Sans Bold',
        light: 'Nimbus Sans Light'
    },
    fontVars: {
        xxsmall: '10px',
        xsmall: '12px',
        small: '14px',
        medium: '16px',
        mediumLH: '22px',
        xmedium: '18px',
        large: '20px',
        xlarge: '24px',
        xxlarge: '36px',
        xxxlarge: '48px',
        titleFont: '18px',
        labelSupFont: '100%',
        h1Font: '56px',
        h2Font: '48px',
        h3Font: '40px',
        h4Font: '32px',
        h4FontLH: '38px',
        h5Font: '24px',
        h6Font: '20px',
        title: '40px',
        subtitle1: '16px',
        body1: '16px',
        body2: '12px',
        caption: '12px',
        p1Font: '16px',
        p2Font: '14px',
        h1FontMobile: '40px',
        h2FontMobile: '32px',
        h3FontMobile: '32px',
        h4FontMobile: '24px',
        h5FontMobile: '24px'
    },
    gutterFPS: 4,
    spacingVars: {
        small: '8px',
        medium: '12px',
        xmedium: '16px',
        xxmedium: '20px',
        xxxmedium: '24px',
        large: '28px',
        xlarge: '32px',
        xxlarge: '48px'
    },
    palette: {
        interactiveBlue: '#086EA1',
        white: '#FFFFFF',
        background: {
            default: '#FFFFFF'
        },
        darkBlue: '#054C70',
        charcoal: '#3B4B59',
        paleBlue: '#CEE0E8',
        hoverBlue: '#043954',
        brightBlue: '#05C3DE',
        lightGray: '#EBEBEB ',
        cardFooterGray: '#F0F3F5',
        gray: '#C4C4C4',
        mediumGray: '#898989',
        darkGray: '#3B3B3B',
        successGreen: '#7D9845',
        warningOrange: '#E17A17',
        errorRed: '#D82C26',
        appBarGradient: 'radial-gradient(farthest-corner at 20% -100%, #05C3DE -25%, #054C70 60%, #063046 105%)'
    },
    boxShadow:
        '0px 0px 8px rgba(59, 59, 59, 0.12), 0px 6px 4px rgba(59, 59, 59, 0.05), 0px 3px 3px rgba(59, 59, 59, 0.05)',
    boxShadowHover:
        '0px 2px 15px rgba(59, 59, 59, 0.1), 0px 10px 15px rgba(0, 0, 0, 0.12), 0px 4px 3px rgba(0, 0, 0, 0.04)',
    boxShadowError:
        ' 0px 8px 8px rgba(45, 57, 64, 0.075), 0px 0px 4px rgba(45, 57, 64, 0.075)',
    boxShadowErrorHover:
        '0px 24px 24px rgba(45, 57, 64, 0.075), 0px 0px 12px rgba(45, 57, 64, 0.075)',
    colors: {
        darkBlue: '#054C70',
        paleBlue: '#CEE0E8',
        hoverBlue: '#043954',
        brightBlue: '#05C3DE',
        charcoal: '#3B4B59',
        lightGray: '#EBEBEB ',
        gray: '#C4C4C4',
        interactiveBlue: '#086EA1',
        mediumGray: '#898989',
        darkGray: '#3B3B3B',
        successGreen: '#7D9845',
        warningOrange: '#E17A17',
        white: '#FFFFFF',
        errorRed: '#D82C26',
    },
    typography:{
        fontFamily: ['Nimbus Sans Reg', 'Nimbus Sans Light', 'Nimbus Sans Bold'],
        caption:{
            letterSpacing: '0.03333em'
        },
        body1: {
            letterSpacing: '0.00938em'
        },
        h4:{
            letterSpacing: '0.00735em'
        },
        h1Font: '56px',
        h2Font: '48px',
        h3Font: '40px',
        h4Font: '32px',
        h5Font: '24px',
        h6Font: '20px',
        title: '40px',
        subtitle1: '16px',
        body2: '12px',
        p1Font: '16px',
        p2Font: '14px',
        h1FontMobile: '40px',
        h2FontMobile: '32px',
        h3FontMobile: '32px',
        h4FontMobile: '24px',
        h5FontMobile: '24px'
    },
    overrides: {
        MuiGrid: {
			root: {
				maxWidth: '1234px',
				margin: '0 auto'
			},
			item: {
				padding: '0 !important'
			}
		},
		MuiButton: {
			label: {
				whiteSpace: 'nowrap'
			}
		},
        MuiCssBaseline: {
            '@global':{
                '@font-face': [
                    {fontFamily: 'Nimbus Sans Reg',
                    src: `
                        url('../fonts/75144806-5cb9-4743-95cf-40b7f3df5dda.eot'),
                        url('../fonts/75144806-5cb9-4743-95cf-40b7f3df5dda.eot?#iefix') format('eot'),
                        url('../fonts/4e93482e-40f7-4349-a9c2-f8882f15a93b.woff') format('woff'),
                        url('../fonts/55bc1387-86c7-452b-ae79-2721ea3b0645.ttf') format('truetype'),
                        url('../fonts/b5edab57-23a8-4bc5-bab3-df39a838bd75.svg#b5edab57-23a8-4bc5-bab3-df39a838bd75') format('svg')
                        `
                },
                {
                    fontFamily: 'Nimbus Sans Bold',
                    src: `
                        url('../fonts/9dca25dd-18d2-4ec8-a997-ef28c2f4f136.eot?#iefix'),
                        url('../fonts/9dca25dd-18d2-4ec8-a997-ef28c2f4f136.eot?#iefix?#iefix') format('eot'),
                        url('../fonts/ce398c7a-fb54-4409-89f7-241065e2af3d.woff') format('woff'),
                        url('../fonts/fd862b64-8bf7-47e5-81d6-ee4cc1ac851f.ttf') format('truetype'),
                        url('../fonts/75896f69-6e33-4f29-97b1-1a105d9d6396.svg#75896f69-6e33-4f29-97b1-1a105d9d6396') format('svg');
                        `
                },
                {
                    fontFamily: 'Nimbus Sans Light',
                    src: `
                        url('../fonts/5838f40c-4590-4e32-b164-c2971fcef883.eot?#iefix'),
                        url('../fonts/5838f40c-4590-4e32-b164-c2971fcef883.eot?#iefix') format('eot'),
                        url('../fonts/0735b4aa-4513-4002-8c4d-1b5dd2f43b74.woff2') format('woff2'),
                        url('../fonts/5fe27aff-ba5a-4022-adaf-b8fa6f8642cb.woff') format('woff'),
                        url('../fonts/50c13c0a-595a-4cca-b4cc-2edcd6eb67aa.ttf') format('truetype')
                        `
                    }
                ]
            }
        },
        '& .arrow-icon': {
            '&:hover': {
                backgroundColor: 'initial',
                color: 'initial',
                border: 'none',
            },
        },
    }
};

export const fpsColors = {
    darkBlue: '#054C70',
    paleBlue: '#CEE0E8',
    hoverBlue: '#043954',
    brightBlue: '#05C3DE',
    lightGray: '#EBEBEB ',
    gray: '#C4C4C4',
    mediumGray: '#898989',
    darkGray: '#3B3B3B',
    successGreen: '#7D9845',
    warningOrange: '#E17A17',
    errorRed: '#D82C26',
    interactiveBlue: '#086EA1'
};
export const fontVars = {
    xxsmall: '10px',
    xsmall: '12px',
    small: '14px',
    medium: '16px',
    xmedium: '18px',
    large: '20px',
    xlarge: '24px',
    xxlarge: '36px',
    xxxlarge: '48px',
    titleFont: '18px',
    labelSupFont: '100%',
    h1Font: '56px',
    h2Font: '48px',
    h3Font: '40px',
    h4Font: '32px',
    h5Font: '24px',
    h6Font: '20px',
    title: '40px',
    subtitle1: '16px',
    body1: '16px',
    body2: '12px',
    caption: '12px',
    p1Font: '16px',
    p2Font: '14px',
    h1FontMobile: '40px',
    h2FontMobile: '32px',
    h3FontMobile: '32px',
    h4FontMobile: '24px',
    h5FontMobile: '24px'
};

export const spacingVars = {
    spacingVars: {
        small: 8,
        medium: 12,
        xmedium: 16,
        xxmedium: 20,
        xxxmedium: 24,
        large: 28,
        xlarge: 32,
        xxlarge: 48
    }
}

export default theme;
